import React from 'react';
import { motion } from 'framer-motion';
import { homepageContent, siteContent } from '../../data/products';
import Icon from '../Icon/Icon';
import { Reveal, fadeUp, staggerWrap } from '../../motion';
import './About.css';

const About = () => {
  const content = homepageContent.founderStory;
  const features = content.features;
  const instagramUrl = siteContent.contact.instagramUrl;

  return (
  <section id="about" className="about">
    <div className="about-container">
      <Reveal className="about-image-col" y={24}>
        <div className="about-img-wrapper" data-parallax="0.05">
          <img
            src={content.mainImage}
            alt={content.mainImageAlt}
            className="about-img-main"
            loading="lazy"
            decoding="async"
            width={800}
            height={600}
          />
          <motion.div
            className="about-img-badge"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: 'easeOut', delay: 0.25 }}
          >
            <div className="about-img-badge-inner">
              <span className="badge-icon"><Icon name="shield" size={26} /></span>
              <span className="badge-text">{siteContent.legal.fssaiStatus}</span>
            </div>
          </motion.div>
          <motion.div
            className="about-img-float"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: 'easeOut', delay: 0.15 }}
          >
            <img
              src={content.floatImage}
              alt={content.floatImageAlt}
              className="about-img-float-inner"
            />
          </motion.div>
        </div>
      </Reveal>
      <div className="about-content-col">
        <Reveal y={24}>
          <div className="about-tag">{content.eyebrow}</div>
          <h2 className="section-title about-title">
            {content.title}<br/><em>{content.titleAccent}</em>
          </h2>
          {content.paragraphs.map((paragraph) => (
            <p className="about-text" key={paragraph}>{paragraph}</p>
          ))}
        </Reveal>
        <motion.div
          className="about-features"
          variants={staggerWrap(0.1, 0.1)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          {features.map((f, i) => (
            <motion.div
              className="feature-card"
              key={i}
              variants={fadeUp(0, 24)}
            >
              <span className="feature-icon"><Icon name={f.icon} size={22} /></span>
              <div>
                <h3 className="feature-title">{f.title}</h3>
                <p className="feature-desc">{f.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
        <Reveal delay={0.15} y={20}>
          <a
            href={instagramUrl}
            target="_blank"
            rel="noreferrer"
            className="about-ig-btn"
          >
            <Icon name="instagram" size={18} strokeWidth={1.8} />
            <span>{content.instagramCta}</span>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
export default About;
